import { SignInWithProviderButtons, } from 'root/src/client/v2/auth/components/SignInWithProviderButtons';
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import { ModalLayout } from '../../common/layouts/ModalLayout';
export function SignInWithProvidersModal() {
    return (<ModalLayout>
			<ModalTitle>Connect Channels</ModalTitle>
			<SignInWithProviderButtons isLinking className="flex flex-col w-[280px] gap-3"/>
		</ModalLayout>);
}
